import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Grid } from '../../grid';

export interface AppCardGridProps extends HTMLAttributes<HTMLDivElement> {}

export const AppCardGrid: FC<AppCardGridProps> = ({ className, ...props }) => (
    <Grid className={classNames('app-card__grid', className)} {...props} />
);
